import { useState, useEffect } from "react";
import combinedServices from "../../../../shared/services/user-service";
import pencilIcon from "../../../../assets/images/pencil.svg";
import deleteIcon from "../../../../assets/images/bin.svg";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const CategoryComponent = ({
  storeID,
  page,
  limit,
  searchQuery,
  setPage,
  setLimit,
  setSearchQuery,
  categories,
  setCategories,
  totalCategories,
  setTotalCategories,
  deleteStatus,
  setdeleteStatus,
  adminstoreview
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const totalPages = Math.ceil(totalCategories / limit);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        if (storeID) {
          let catagoryList = await combinedServices.getCategory(
            page,
            limit,
            searchQuery,
            storeID
          );
          if (catagoryList && catagoryList.data.categories) {
            setCategories(catagoryList.data.categories || []);
            setTotalCategories(catagoryList.data.total || 0);
          }
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, [storeID, page, limit, searchQuery, deleteStatus, isModalOpen]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  const handleButtonClick = () => {
    navigate("/add-category", { state: { storeID,adminstoreview } });
  };

  const updateCatagories = async (category_id, category) => {
    try {
      if (!category_id || !category) {
        throw new Error("Category ID and name must be provided.");
      }

      const catagoryData = { category_id, category };
      const updatedCatagory = await combinedServices.updateCategory(
        catagoryData
      );

      if (updatedCatagory?.status === 200) {
        setIsModalOpen(false);
        Swal.fire(
          "Updated!",
          updatedCatagory.data.message || "The category has been Updated.",
          "success"
        );
      } else {
        Swal.fire("Warning!", "Error in updation", "warning");
      }
    } catch (error) {
      if (error.response?.status === 409) {
        Swal.fire(
          "Error!",
          error.response.data.message || "This category has Connected to Products",
          "error"
        );
      } else {
        Swal.fire("Warning!", "Error in updation", "warning");
      }
    }
  };

  const deleteCatagory = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        const response = await combinedServices.deleteCategory({
          category_id: id,
        });
        if (response.data.status === 200) {
          setdeleteStatus(response.data.message);
          Swal.fire(
            "Deleted!",
            response.data.message || "The category has been deleted.",
            "success"
          );
        } else if (response.data.status === 400) {
          setdeleteStatus(response.data.message);
          Swal.fire(
            "Warning!",
            response.data.message || "This category has Connected to Products",
            "warning"
          );
        } else {
          Swal.fire(
            "Warning!",
            "The category may have been deleted, but an unexpected response was received.",
            "warning"
          );
        }
      }
    } catch (error) {
      console.error("Error deleting category:", error);
      Swal.fire("Error!", "Failed to delete the category.", "error");
    }
  };

  const toggleCategoryStatus = async (id) => {
    try {
      const response = await combinedServices.changeStatus({ category_id: id });
      if (response.status === 200) {
        setdeleteStatus(response.data.message);
        Swal.fire(
          "Changed!",
          response.data.message || "The category has been deleted.",
          "success"
        );
      } else {
        Swal.fire(
          "Warning!",
          "The category status may have been Changes, but an unexpected response was received.",
          "warning"
        );
      }
    } catch (error) {
      console.error("Error changing status:", error);
      Swal.fire("Error!", "Failed to change status of category.", "error");
    }
  };

  return (
    <>
      <div className="storeFilter d-flex justify-content-between align-items-center">
        <form>
          <div className="catFilterCont">
            <div className="filWrp d-flex flex-wrap align-items-center">
              <label className="label2">Showing</label>
              <select
                className="formSelect ms-2 me-2"
                value={limit}
                onChange={handleLimitChange}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <span className="ent">entries</span>
              <div className="srchGrp ms-3">
                <input
                  type="text"
                  className="formInput"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  placeholder="Search here..."
                />
              </div>
            </div>
          </div>
        </form>
        <button className="nambaBtn" onClick={handleButtonClick}>
          + Add New Category
        </button>
      </div>
      &nbsp;
      <div className="tblWrp">
        <table>
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Category Name</th>
              <th>Created On</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((category, index) => (
              <tr key={category.category_id}>
                <td>{(page - 1) * limit + index + 1}</td>
                <td>
                  <div className="catPara">
                    <img src={category.category_img} alt="categoryIcon" />
                    {category.category}
                  </div>
                </td>
                <td>{new Date(category.updatedOn).toLocaleDateString()}</td>
                <td>
                  <div className="tblBtnWrp">
                    <button className="Btn">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={category.status}
                          onChange={() =>
                            toggleCategoryStatus(category.category_id)
                          }
                        />
                        <span className="slider"></span>
                      </label>
                    </button>
                    <button
                      className="Btn"
                      onClick={() => {
                        setSelectedCategory(category);
                        setIsModalOpen(true);
                      }}
                    >
                      <img src={pencilIcon} alt="Edit" />
                    </button>
                    <button
                      className="Btn"
                      onClick={() => deleteCatagory(category.category_id)}
                    >
                      <img src={deleteIcon} alt="Delete" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="tblPagiWrp">
          <ul className="pagination namPagi">
            <li>
              <button
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 1}
              >
                Prev
              </button>
            </li>
            {Array.from({ length: totalPages }, (_, index) => (
              <li key={index}>
                <button
                  className={page === index + 1 ? "active" : ""}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
            <li>
              <button
                onClick={() => handlePageChange(page + 1)}
                disabled={page === totalPages}
              >
                Next
              </button>
            </li>
          </ul>
        </div>
      </div>
      <CategoryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        updateCatagories={updateCatagories}
        category={selectedCategory}
      />
    </>
  );
};

const CategoryModal = ({ isOpen, onClose, category, updateCatagories }) => {
  const [categoryName, setCategoryName] = useState("");
  const [isSocialEvents, setIsSocialEvents] = useState(false);

  const capitalizeFirstLetter = (text) => {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  useEffect(() => {
    if (category) {
      const catName = capitalizeFirstLetter(category.category || "");
      setCategoryName(catName);
      setIsSocialEvents(catName === "Social Events");
    }
  }, [category]);

  if (!isOpen) return null;

  const handleSave = () => {
    if (category && category.category_id) {
      updateCatagories(category.category_id, categoryName);
    }
  };

  const handleInputChange = (e) => {
    setCategoryName(capitalizeFirstLetter(e.target.value));
  };

  const handleSocialEventsChange = (e) => {
    const checked = e.target.checked;
    setIsSocialEvents(checked);
    if (checked) {
      setCategoryName("Social Events");
    } else {
      setCategoryName("");
    }
  };

  return (
    <>
      <style>
        {`
          .social-events-checkbox {
            margin-bottom: 20px;
            padding: 16px 20px;
            background: linear-gradient(135deg, #f8f9fa 0%, #ededed 100%);
            border-radius: 12px;
            border: 1px solid #d1d5db;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
            transition: all 0.2s ease;
          }
          .social-events-checkbox:hover {
            border-color: #01458b;
            box-shadow: 0 4px 8px rgba(1, 69, 139, 0.1);
          }
          .social-events-checkbox label {
            display: flex;
            align-items: center;
            cursor: pointer;
            font-weight: 600;
            margin: 0;
            color: #374151;
            font-size: 15px;
            user-select: none;
          }
          .social-events-checkbox .checkbox-wrapper {
            position: relative;
            margin-right: 14px;
            display: flex;
            align-items: center;
          }
          .social-events-checkbox input[type="checkbox"] {
            opacity: 0;
            position: absolute;
            width: 22px;
            height: 22px;
            margin: 0;
            cursor: pointer;
          }
          .social-events-checkbox .checkbox-custom {
            width: 22px;
            height: 22px;
            background: #ffffff;
            border: 2px solid #d1d5db;
            border-radius: 6px;
            position: relative;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .social-events-checkbox input[type="checkbox"]:checked + .checkbox-custom {
            background: linear-gradient(135deg, #01458b 0%, #0056b3 100%);
            border-color: #01458b;
            transform: scale(1.05);
          }
          .social-events-checkbox .checkbox-custom::after {
            content: "";
            position: absolute;
            width: 6px;
            height: 10px;
            border: solid white;
            border-width: 0 2.5px 2.5px 0;
            transform: rotate(45deg) scale(0);
            transition: transform 0.2s ease-in-out;
          }
          .social-events-checkbox input[type="checkbox"]:checked + .checkbox-custom::after {
            transform: rotate(45deg) scale(1);
          }
          .social-events-checkbox input[type="checkbox"]:focus + .checkbox-custom {
            box-shadow: 0 0 0 3px rgba(1, 69, 139, 0.2);
          }
          .social-events-checkbox .checkbox-text {
            color: #01458b;
            font-weight: 700;
          }
          .category-form input[type="text"]:disabled {
            background: linear-gradient(135deg, #f3f4f6 0%, #ededed 100%);
            opacity: 0.8;
            cursor: not-allowed;
            color: #9ca3af;
            border-color: #d1d5db;
          }
        `}
      </style>
      <div className="catagorylistmodal">
        <div className="catagorylistmodal-content">
          <h2>Edit Category</h2>
          <br />
          <form className="category-form">
            <div className="social-events-checkbox">
              <label>
                <div className="checkbox-wrapper">
                  <input
                    type="checkbox"
                    checked={isSocialEvents}
                    onChange={handleSocialEventsChange}
                  />
                  <div className="checkbox-custom"></div>
                </div>
                <span className="checkbox-text">Social Events</span>
              </label>
            </div>
            <label htmlFor="category-name">Category Name</label>
            <input
              id="category-name"
              type="text"
              value={categoryName}
              onChange={handleInputChange}
              placeholder="Enter category name"
              disabled={isSocialEvents}
            />
            <div className="catagorylistmodal-actions">
              <div className="cancel-icon" onClick={onClose}>
                &#10006;
              </div>
              <button type="button" className="save-btn" onClick={handleSave}>
                Save
              </button>
            </div>
          </form>
        </div>
        <div className="catagorylistmodal-overlay" onClick={onClose}></div>
      </div>
    </>
  );
};

export default CategoryComponent;
